import { DayOrdersStatistics } from '@api/shipping-data/types/DayOrdersStatistics';
import { StatisticCardData, StatisticCardState } from 'components/statistic-card/StatisticCardData';
import { StatisticModel } from '@pages/preview/cards-area/StatisticModel';
import { getDefaultNumber } from 'components/global/utils';



export const convertToStatisticModel = (summary: DayOrdersStatistics | null | undefined): StatisticModel | null => {
	if (!summary) return null;


	// --- first row ---
	
	const totalOrders: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Celkem objednáno',
		tooltip: 'Počet obj na daný den (bez obj předatumovaných na jiný den).\u00a0HL jsou z 1 verze obj.',
		value: getDefaultNumber(summary.totalOrders),
		volume: getDefaultNumber(summary.totalOrdersItemsVolume),
	}
	const redated: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Předatumované z předchozích dnů',
		tooltip: 'Počet předatumovaných obj z jiného dne na vybraný den.\u00a0HL z 1.verze obj.',
		value: getDefaultNumber(summary.totalRedatedOrders),
		volume: getDefaultNumber(summary.totalRedatedOrdersVolume),
		percent: getDefaultNumber(summary.totalRedatedOrdersPct),
	}
	const outgoingRedated: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Předatumované na další den',
		tooltip: 'Počet obj předatumovaných z daného dne na jiný den.\u00a0HL z 1.verze obj.',
		value: getDefaultNumber(summary.totalOutgoingRedatedOrders),
		volume: getDefaultNumber(summary.totalOutgoingRedatedOrdersVolume),
		percent: getDefaultNumber(summary.totalOutgoingRedatedOrdersPct),
	}
	const cancelledPlanning: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Zrušené před rozvozem',
		tooltip: 'Počet zrušených obj ve fázi plánování (SAP):\u00a0zrušil PPAS / celkem zrušeno (PPAS + CUST).\u00a0HL z 1.verze obj.',
		value: getDefaultNumber(summary.totalCancelledOrdersPpasPlanning),
		maxValue: getDefaultNumber(summary.totalCancelledOrdersPlanning),
		volume: getDefaultNumber(summary.totalCancelledOrdersVolumePlanning),
		percent: getDefaultNumber(summary.totalCancelledOrdersPlanningPct),
	}
	const reducedPlanning: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Pokrácené před rozvozem',
		tooltip: 'Počet pokrácených obj ve fázi plánování (SAP):\u00a0pokrátil PPAS / celkem pokráceno (PPAS + CUST).\u00a0HL z 1.verze obj.',
		value: getDefaultNumber(summary.totalReducedOrdersPpasPlanning),
		maxValue: getDefaultNumber(summary.totalReducedOrdersPlanning),
		volume: getDefaultNumber(summary.totalReducedOrdersVolumePlanning),
		percent: getDefaultNumber(summary.totalReducedOrdersPlanningPct),
	}
	const changedPlanning: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Všechny změny před rozvozem',
		tooltip: 'Předatumované na další den + zrušené před rozvozem + pokrácené před rozvozem.',
		value: getDefaultNumber(summary.totalChangedOrdersPpasPlanning),
		maxValue: getDefaultNumber(summary.totalChangedOrdersPlanning),
		volume: getDefaultNumber(summary.totalChangedOrdersVolumePlanning),
		percent: getDefaultNumber(summary.totalChangedOrdersPlanningPct),
	}

	// --- second row ---

	const toBeDelivered: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Celkem k rozvozu',
		tooltip: 'Celkem objednáno + Předatumované z předchozích dnů - Předatumované na další den - Zrušené před rozvozem.\u00a0HL z poslední verze dodávky (plánování).',
		value: getDefaultNumber(summary.totalToBeDeliveredDeliveries),
		volume: getDefaultNumber(summary.totalToBeDeliveredDeliveriesVolume),
	}
	const delivered: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Doručeno',
		tooltip: 'Počet doručených objednávek a HL z poslední verze z mDSD.',
		value: getDefaultNumber(summary.totalDeliveredDeliveries),
		volume: getDefaultNumber(summary.totalDeliveredDeliveriesVolume),
		percent: getDefaultNumber(summary.totalDeliveredDeliveriesPct),
	}
	const beingDelivered: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Na cestě',
		tooltip: 'Počet obj na rozvozu\u00a0HL z poslední verze dodávky (plánování).',
		value: getDefaultNumber(summary.totalBeingBeDeliveredDeliveries),
		volume: getDefaultNumber(summary.totalBeingBeDeliveredDeliveriesVolume),
		percent: getDefaultNumber(summary.totalBeingDeliveredOrdersPct),
	}
	const remaining: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Zbývá na DC',
		tooltip: 'Celkem k rozvozu - Doručeno - Na cestě.',
		value: getDefaultNumber(summary.totalOrdersOnDc),
		volume: getDefaultNumber(summary.totalOrdersVolumeOnDc),
		percent: getDefaultNumber(summary.totalOrdersOnDcPct),
	}
	const dispatched: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Vychystáno na DC',
		tooltip: '',
		value: 0,
		volume: 0,
		percent: 0,
	}
	const remainingDispatched: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Zbývá vychystat na DC',
		tooltip: '',
		value: 0,
		volume: 0,
		percent: 0,
	}

	// --- third row ---

	const perfectlyDelivered: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Perfektně doručené',
		tooltip: 'Doručeno - Nedoručeno - Pokrácené při rozvozu/z Doručeno.',
		value: getDefaultNumber(summary.totalPerfectlyDeliveredDeliveries),
		maxValue: getDefaultNumber(summary.totalDeliveredDeliveries),
		volume: getDefaultNumber(summary.totalPerfectlyDeliveredDeliveriesVolume),
		percent: getDefaultNumber(summary.totalPerfectlyDeliveredOrdersPct),
		state:
			summary.totalPerfectlyDeliveredOrdersPct >= 96 ? StatisticCardState.success :
			summary.totalPerfectlyDeliveredOrdersPct >= 90 ? StatisticCardState.warning :
			StatisticCardState.danger,
	}
	const notDelivered: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Nedoručeno',
		tooltip: 'Chyba PPAS / Celkem nedoručeno (chyba PPAS + CUST).',
		value: getDefaultNumber(summary.totalNotDeliveredDeliveriesDueToPpas),
		maxValue: getDefaultNumber(summary.totalNotDeliveredDeliveries),
		volume: getDefaultNumber(summary.totalNotDeliveredDeliveriesVolume),
		percent: getDefaultNumber(summary.totalNotDeliveredDeliveriesPct),
		state:
			summary.totalNotDeliveredDeliveriesPct < 5 ? StatisticCardState.success :
			summary.totalNotDeliveredDeliveriesPct <= 10 ? StatisticCardState.warning :
			StatisticCardState.danger,
	}
	const reducedExecution: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Pokrácené při rozvozu',
		tooltip: 'Počet pokrácených obj v mDSD.\u00a0Pokrátil PPAS / celkem pokráceno (PPAS + CUST).\u00a0HL z poslední verze mDSD dodávky.',
		value: getDefaultNumber(summary.totalReducedOrdersPpasExecution),
		maxValue: getDefaultNumber(summary.totalReducedOrdersExecution),
		volume: getDefaultNumber(summary.totalReducedOrdersVolumeExecution),
		percent: getDefaultNumber(summary.totalReducedOrdersExecutionPct),
		//state: ,
	}
	const notPerfectlyDelivered: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Neperfektní objednávky celkem',
		tooltip: 'Nedoručeno + Pokrácené při rozvozu.\u00a0Chyba PPAS / Celkem neperfektních objednávek (chyba PPAS + CUST).',
		value: getDefaultNumber(summary.totalNotPerfectOrdersPpas),
		maxValue: getDefaultNumber(summary.totalNotPerfectOrders),
		volume: getDefaultNumber(summary.totalNotPerfectOrdersVolume),
		percent: getDefaultNumber(summary.totalNotPerfectOrdersPct),
		//state: ,
	}

	// --- four row ---

	const deliveredOnTime: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Doručené přesně na čas',
		tooltip: 'Počet obj doručených na čas / z Doručeno.\u00a0HL z poslední verze dodávky.',
		value: getDefaultNumber(summary.totalDeliveredDeliveriesOnTime),
		maxValue: getDefaultNumber(summary.totalDeliveredDeliveries),
		volume: getDefaultNumber(summary.totalDeliveredDeliveriesVolumeOnTime),
		percent: getDefaultNumber(summary.totalOnTimeDeliveredOrdersPct),
		state:
			summary.totalOnTimeDeliveredOrdersPct >= 85 ? StatisticCardState.success :
			summary.totalOnTimeDeliveredOrdersPct >= 80 ? StatisticCardState.warning :
			StatisticCardState.danger,
	}
	const deliveredOnSmsTime: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Doručené přesně dle SMS',
		tooltip: 'Počet doručených obj zákazníkům, kterým byla odeslána SMS / z celkového počtu odeslaných SMS.',
		value: getDefaultNumber(summary.totalDeliveredDeliveriesOnSmsTime),
		maxValue: getDefaultNumber(summary.totalOrdersWithSmsSent),
		volume: getDefaultNumber(summary.totalDeliveredDeliveriesWithSmsSent),
		percent: getDefaultNumber(summary.totalOnSmsTimeDeliveredOrdersPct),
		state:
			summary.totalOnSmsTimeDeliveredOrdersPct >= 85 ? StatisticCardState.success :
			summary.totalOnSmsTimeDeliveredOrdersPct >= 80 ? StatisticCardState.warning :
			StatisticCardState.danger,
	}
	const deliveredInTimeSlot: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Doručené přesně dle dodacího okna',
		tooltip: 'Počet obj doručených dle dodacího okna z masterdat zákazníka / z Doručeno.\u00a0HL z poslední verze dodávky mDSD.',
		value: getDefaultNumber(summary.totalDeliveredDeliveriesInTimeSlot),
		maxValue: getDefaultNumber(summary.totalDeliveredDeliveries),
		volume: getDefaultNumber(summary.totalDeliveredDeliveriesVolumeInTimeSlot),
		percent: getDefaultNumber(summary.totalInTimeSlotDeliveredOrdersPct),
		state:
			summary.totalInTimeSlotDeliveredOrdersPct >= 85 ? StatisticCardState.success :
			summary.totalInTimeSlotDeliveredOrdersPct >= 80 ? StatisticCardState.warning :
			StatisticCardState.danger,
	}
	const departures: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Odjezdy přesně z DC',
		tooltip: 'Shipment přepnutý do status 6 značí odjezd z DC.\u00a0Plánovaný čas odjezdu z DC.',
		value: getDefaultNumber(summary.totalDepotDeparturesOnTime),
		maxValue: getDefaultNumber(summary.totalDepotDepartures),
		volume: getDefaultNumber(summary.totalDepotDeparturesVolumeOnTime),
		percent: getDefaultNumber(summary.totalDepotDeparturesOnTimePct), 
		//state: ,
	}


	const createdStatistics: StatisticModel = {
		totalOrders,
		redated,
		outgoingRedated,
		cancelledPlanning,
		reducedPlanning,
		changedPlanning,
		toBeDelivered,
		delivered,
		beingDelivered,
		remaining,
		dispatched,
		remainingDispatched,
		perfectlyDelivered,
		notDelivered,
		reducedExecution,
		notPerfectlyDelivered,
		deliveredOnTime,
		deliveredOnSmsTime,
		deliveredInTimeSlot,
		departures,
	}
	return createdStatistics;
}